import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class VagaService {
  private readonly path = 'profissionais';

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllVaga`,
      this.getParams(params),
      true
    );
  }
  getTotalDisponivel(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getVagaTotalDisponivel`,
      this.getParams(params),
      true
    );
  }
  show(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getVagaById/${id}`,
      this.getParams(),
      true
    );
  }
  cancelar(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/getVagaCancelar`,
      data,
      {},
      true
    );
  }
  notificarNova(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/NotificarNovaVaga`,
      data,
      {},
      true
    );
  }
  add(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/AddVaga`,
      data,
      {},
      true
    );
  }
  update(data: any): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdateVaga`,
      data,
      this.getParams(),
      true
    );
  }
  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteVagaById/${id}`,
      this.getParams(),
      true
    );
  }
  enviarEmail(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/EnviarEmail`,
      data,
      {},
      true
    );
  }
  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}